export enum SubDomainEnum {
    NotSet = 0,
    IndicatorFactory = 1,
    Portal = 2,
    ValidationEngine = 3,
    PerformanceReports = 4,
    NdnqiPublicReports = 5,
    SystemManagement = 6,
    LearningManagement = 7,
    MicroStrategy = 8,
    NdnqiFoundation = 9
}
